//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TalksMap from "@/utils/initMapTalks.js";
export default {
  data() {
    return {
      TalksMapDialog: new TalksMap(),
      landList: [], // 所有的地块
      landTotalInfo: {}, // 地块总的信息
      mapHasHover: true,
      mapHasSelected: false,
      coordinate: [116.177427669, 28.861500052],
    };
  },
  props: {
    contractId: {
      type: String,
    },
  },
  watch: {
    landList: {
      handler: function (n) {
        console.log(n);
        this.TalksMapDialog.land(
          this.landList,
          "croplandEdge",
          "",
          this.mapHasHover,
          this.mapHasSelected
        );
      },
    },
  },
  mounted() {
    this.TalksMapDialog.sendThis(this);
    this.getMapInit();
    this.getLandList({ contractId: this.contractId });
  },
  methods: {
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getLandList(params) {
      this.$http.contract.getContractDetailLands(params).then((res) => {
        let { contractLandProtocols, ...data } = res.data;
        this.landTotalInfo = data;
        if (contractLandProtocols.length > 0) {
          this.landList = contractLandProtocols;
          let lng, lat;
          if (this.landList.length == 0) {
            lng = 116.177427669;
            lat = 28.861500052;
          } else {
            let temp = JSON.parse(this.landList[0].centroid).coordinates;
            lng = temp[0];
            lat = temp[1];
          }
          let Coordinate = {
            x: lng,
            y: lat,
          };
          this.coordinate = Coordinate;
        }
      });
    },
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("mapDiv", 16);
    },
  },
};
